import {BODY_TEXT_COLOR, NEGATIVE_COLOR} from '../../config/colors';

const styles = {
  selectorWrapper: {
    margin: '10px auto 0',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    width: '290px'
  },
  handsFreeWrapper: {
    margin: '0 auto',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    width: '290px'
  },
  secondaryButtonColor: NEGATIVE_COLOR,
  labelStyle: {fontWeight: 700},
  button: {width: '120px'},
  priceWrapper: {
    margin: '10px 0 21px',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column'
  },
  header: {
    'textAlign': 'center',
    'textTransform': 'uppercase',
    'padding': '10px 0',
    'borderBottom': '1px #e6e6e6 solid',
    'fontWeight': '800',
    'color': BODY_TEXT_COLOR
  },
  priceHeader: {
    width: '290px',
    margin: '10px 0 -12px',
    color: '#616161',
    fontSize: '16px'
  },
  clearBtn: {
    margin: 12,
    width: '110px'
  },
  clearBtnLabel: {
    color: '#fff'
  },
  applyBtn: {
    margin: 12,
    width: '110px',
    background: '#689F38'
  },
  slider: {
    zIndex: '1',
    width: '258px',
    height: '30px',
    margin: '30px 0 10px'
  },
  bottomContainer: {
    background: '#fff',
    position: 'absolute',
    bottom: '0px',
    marginBottom: '5px',
    width: '100%',
    textAlign: 'center',
    zIndex: '2'
  },
  drawer: {
    top: '64px',
    height: '90%',
    scroll: 'hidden'
  }
};

export default styles;



// WEBPACK FOOTER //
// ./src/components/FilterBar/defaultStyles.js